import React from "react";
import styles from "./GameDetails.module.scss";
import { SonicGameDetailData } from "../../common/classes/SonicGameDetail";
import { useGetGameSelection } from "../../utils/useGameSelection";
import { SonicTermData } from "../../common/classes/SonicTerm";
import GameDetailItem from "./GameDetailItem";
import LoadingSpinner from "../../common/LoadingSpinner";

type Props = {
  myGames: Array<SonicTermData>;
  details: Array<SonicGameDetailData>;
};
const GameDetails: React.FC<Props> = ({ myGames, details }) => {
  const { gameSelections, isLoading } = useGetGameSelection();

  const genIndexArray = (
    myGames: Array<SonicTermData>,
    details: Array<SonicGameDetailData>
  ) => {
    const result: Array<{ gameIndex: number; detailIndex: number }> = [];

    myGames.forEach((game, i) => {
      const detail_index = details.findIndex((d) => d.game_id === game.id);

      if (detail_index !== -1)
        result.push({ gameIndex: i, detailIndex: detail_index });
    });

    return result;
  };

  if (isLoading) {
    return <LoadingSpinner space={1} />;
  }

  return (
    <dl className={styles["game-details"]}>
      {genIndexArray(myGames, details).map((obj, i) => (
        <GameDetailItem
          key={i}
          gameName={myGames[obj.gameIndex].name}
          selectionData={
            gameSelections.filter(
              (s) => s.game_id === myGames[obj.gameIndex].id
            )[0]
          }
          detailData={details[obj.detailIndex]}
        />
      ))}
    </dl>
  );
};

export default GameDetails;
